(function ($) {
  function truncate() {
      const $truncate = $('.c-truncate');
      $truncate.removeClass('c-truncate--shadow').each((ind, el) => {
        const curTruncate = $(el);
        const curTruncateInner = curTruncate.find('.c-truncate__inner');
        if (curTruncateInner.width() > curTruncate.width()) {
          curTruncate.addClass('c-truncate--shadow');
        }
      });
  }

  $(window).on('load resize', () => {
    setTimeout(() => {
      truncate();
    },100);
  });
}(jQuery));
